import React from "react";
import { Box, Container, Typography, styled, Paper, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  HeroSection,
  HeroTitle,
  HeroSubtitle,
} from "../../../components/hero-section/HeroSection";

const ContentPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: theme.shape.borderRadius * 1.5,
  backgroundColor: "#fff",
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(3),
  },
}));

const Section = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  "&:last-child": {
    marginBottom: 0,
  },
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 600,
  marginBottom: theme.spacing(2),
}));

const Terms = () => {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === 'ps' || i18n.language === 'dr';
  
  return (
    <Box>
      <HeroSection>
        <Container maxWidth="lg">
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={8}>
              <HeroTitle>{t('help.terms.title')}</HeroTitle>
              <HeroSubtitle>
                {t('help.terms.subtitle')}
              </HeroSubtitle>
            </Grid>
          </Grid>
        </Container>
      </HeroSection>

      <Box sx={{ py: 6, backgroundColor: "background.default" }}>
        <Container maxWidth="lg">
          <ContentPaper elevation={0}>
            <Section>
              <SectionTitle variant="h5">{t('help.terms.sections.acceptance.title')}</SectionTitle>
              <Typography variant="body1" paragraph>
                {t('help.terms.sections.acceptance.content')}
              </Typography>
            </Section>

            <Section>
              <SectionTitle variant="h5">
                {t('help.terms.sections.license.title')}
              </SectionTitle>
              <Typography variant="body1" paragraph>
                {t('help.terms.sections.license.content1')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('help.terms.sections.license.content2')}
              </Typography>
            </Section>

            <Section>
              <SectionTitle variant="h5">
                {t('help.terms.sections.digitalContent.title')}
              </SectionTitle>
              <Typography variant="body1" paragraph>
                {t('help.terms.sections.digitalContent.content')}
              </Typography>
            </Section>

            <Section>
              <SectionTitle variant="h5">
                {t('help.terms.sections.account.title')}
              </SectionTitle>
              <Typography variant="body1" paragraph>
                {t('help.terms.sections.account.content')}
              </Typography>
            </Section>

            <Section>
              <SectionTitle variant="h5">{t('help.terms.sections.pricing.title')}</SectionTitle>
              <Typography variant="body1" paragraph>
                {t('help.terms.sections.pricing.content')}
              </Typography>
            </Section>

            <Section>
              <SectionTitle variant="h5">
                {t('help.terms.sections.copyright.title')}
              </SectionTitle>
              <Typography variant="body1" paragraph>
                {t('help.terms.sections.copyright.content')}
              </Typography>
            </Section>

            <Section>
              <SectionTitle variant="h5">{t('help.terms.sections.refund.title')}</SectionTitle>
              <Typography variant="body1" paragraph>
                {t('help.terms.sections.refund.content')}
              </Typography>
            </Section>

            <Section>
              <SectionTitle variant="h5">
                {t('help.terms.sections.limitation.title')}
              </SectionTitle>
              <Typography
                variant="body1"
                paragraph
                sx={{ textTransform: "uppercase" }}
              >
                {t('help.terms.sections.limitation.content')}
              </Typography>
            </Section>

            <Section>
              <SectionTitle variant="h5">{t('help.terms.sections.changes.title')}</SectionTitle>
              <Typography variant="body1" paragraph>
                {t('help.terms.sections.changes.content')}
              </Typography>
            </Section>

            <Section>
              <SectionTitle variant="h5">{t('help.terms.sections.contact.title')}</SectionTitle>
              <Typography variant="body1" paragraph>
                {t('help.terms.sections.contact.content')}
              </Typography>
            </Section>
          </ContentPaper>
        </Container>
      </Box>
    </Box>
  );
};

export default Terms;
